import { GET_DMX_PROFILE_BY_ID, GET_DMX_PROFILE_BY_ID_SUCCESS, GET_DMX_PROFILE_BY_ID_ERROR } from './actionTypes';

export const getDmxProfileById = (user, profileId) => {
  return {
    type: GET_DMX_PROFILE_BY_ID,
    payload: { user, profileId },
  };
};

export const getDmxProfileByIdSuccess = (profile) => {
  return {
    type: GET_DMX_PROFILE_BY_ID_SUCCESS,
    payload: { profile },
  };
};

export const getDmxProfileByIdError = (error) => {
  return {
    type: GET_DMX_PROFILE_BY_ID_ERROR,
    payload: error,
  };
};
